import { Main } from './Main/Main';
import './index.css';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/dates/styles.css';
import '../shared/theme-style.css';
import { createTheme, MantineProvider, rem } from '@mantine/core';

const theme = createTheme({
  fontFamily: 'Poppins',
  fontSizes: {
    xs: rem(12),
    sm: rem(14),
    md: rem(14),
    lg: rem(16),
    xl: rem(20),
  },
});

export const PublicCalendar = () => {
  return (
    <MantineProvider theme={theme}>
      <Main />
    </MantineProvider>
  );
};
